(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-related"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cg-related-products')) {
    customElements.define('cg-related-products', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const track = this.querySelector('[data-rc-track]');
        const prev = this.querySelector('[data-rc-prev]');
        const next = this.querySelector('[data-rc-next]');
        const slide = track.firstElementChild;
        const update = () => {
          const end = track.scrollWidth - track.clientWidth;
          prev.parentElement.hidden = end <= 2;
          prev.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= end - 2;
        };
        const move = (direction) => {
          const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          track.scrollBy({ left: direction * (slide.getBoundingClientRect().width + gap) });
        };
        prev.addEventListener('click', () => move(-1), options);
        next.addEventListener('click', () => move(1), options);
        track.addEventListener('scroll', update, { ...options, passive: true });
        this.observer = new ResizeObserver(update);
        this.observer.observe(track);
        update();
      }

      disconnectedCallback() {
        this.controller.abort();
        this.observer.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
